export const PHOTO_PARAMS = {
	SCALES: [
		{
			value: 'SM',
			label: 'SM',
		},
		{
			value: 'MD',
			label: 'MD',
		},
		{
			value: 'LG',
			label: 'LG',
		},
	],
	POSITIONS: [
		{
			value: 'TOP_LEFT',
			label: 'TOP_LEFT',
		},
		{
			value: 'TOP_RIGHT',
			label: 'TOP_RIGHT',
		},
		{
			value: 'BOTTOM_LEFT',
			label: 'BOTTOM_LEFT',
		},
		{
			value: 'BOTTOM_RIGHT',
			label: 'BOTTOM_RIGHT',
		},
		{
			value: 'TOP',
			label: 'TOP',
		},
		{
			value: 'LEFT',
			label: 'LEFT',
		},
		{
			value: 'CENTER',
			label: 'CENTER',
		},
		{
			value: 'RIGHT',
			label: 'RIGHT',
		},
		{
			value: 'BOTTOM',
			label: 'BOTTOM',
		},
	],
};
Object.freeze(PHOTO_PARAMS);